import getDisabledStatus from './disabled-status';

export default {
  getDisabledStatus,
};
